var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7582 1.3278L0.24235 7.81216C-0.0718583 7.93553 -0.0832703 8.37599 0.224098 8.51545L3.87529 10.1723C3.97418 10.2172 4.04928 10.3021 4.08182 10.4057L5.64833 15.3909C5.72746 15.6426 6.0318 15.7402 6.24251 15.5814L8.96918 13.5272C9.09939 13.4291 9.27749 13.4244 9.41263 13.5156L13.9857 16.6007C14.2138 16.7546 14.5248 16.6241 14.5749 16.3535L17.2734 1.75271C17.3278 1.45801 17.0372 1.21829 16.7582 1.3278ZM6.75003 10.8794L6.25734 13.6803L4.9855 9.66994L13.7051 4.25795L6.75003 10.8794Z",
    fill: "#FF7B29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.1570ae62a1967f03d4710dd9b2729e1b.svg";
export { ForwardRef as ReactComponent };